import { compact, last } from 'lodash';

export const FILE_EXTENSION_DENYLIST = ['exe', 'com', 'bat', 'cmd', 'sh', 'bash', 'zsh'];

export const getFileBasename = (fileName: string): string => {
  const lastDotIndex = fileName.lastIndexOf('.');
  const basename = lastDotIndex === -1 ? fileName : fileName.substring(0, lastDotIndex);
  if (!basename) {
    throw new Error(`Missing file name`);
  }
  return basename;
};

export const getFileExtension = (fileName: string, fallback = 'pdf'): string => {
  const fileParts = compact(fileName.split('.'));
  if (fileParts.length < 2) return fallback;

  return last(fileParts) ?? fallback;
};

export const hasDenyListedExtensions = (fileName: string): boolean => {
  const parts = compact(fileName.toLowerCase().split('.'));
  if (parts.length === 0) return false;

  const lastExt = parts.at(-1);
  const secondToLastExt = parts.at(-2);

  return (
    (lastExt != null && FILE_EXTENSION_DENYLIST.includes(lastExt)) ||
    (secondToLastExt != null && FILE_EXTENSION_DENYLIST.includes(secondToLastExt))
  );
};
